import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState, useCallback } from 'react';
var useGridPagination = function useGridPagination(gridApi) {
  // default to 0, representing no data
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    rowCount = _useState4[0],
    setRowCount = _useState4[1]; // total number of rows to be show in grid
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPage = _useState6[0],
    setCurrentPage = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    lastPage = _useState8[0],
    setLastPage = _useState8[1];
  var updatePagination = useCallback(function () {
    if (gridApi === null) return;
    setPageSize(gridApi.paginationGetPageSize());
    setRowCount(gridApi.paginationGetRowCount());
    setCurrentPage(gridApi.paginationGetCurrentPage() + 1);
    setLastPage(gridApi.paginationGetTotalPages());
  }, [gridApi]);
  useEffect(function () {
    updatePagination();
  }, [updatePagination]);
  var paginationSetPageSize = useCallback(function (size) {
    gridApi.paginationSetPageSize(size);
  }, [gridApi]);
  var paginationGoToPage = useCallback(function (page) {
    gridApi.paginationGoToPage(page - 1);
  }, [gridApi]);
  return {
    pageSize: pageSize,
    rowCount: rowCount,
    currentPage: currentPage,
    lastPage: lastPage,
    paginationSetPageSize: paginationSetPageSize,
    paginationGoToPage: paginationGoToPage,
    updatePagination: updatePagination
  };
};
export default useGridPagination;